import React from 'react';
import { Asset } from 'expo-asset';
import useSceneActivity from './useSceneActivity.web';

const scene = Asset.fromModule(require('@/assets/images/landing-hero-pixel-robot.png')).uri;

// The image and moving details share one coordinate system, so reflections and
// screen details remain anchored to the artwork at every responsive crop.
function LivingPixelScene() {
  const activityRef = useSceneActivity();
  return (
    <svg ref={activityRef} data-scene-active="false" data-pixel-scene="true" aria-hidden="true" focusable="false" viewBox="0 0 1672 941" preserveAspectRatio="xMaxYMid slice" style={{ position: 'absolute', width: '100%', height: '100%', overflow: 'hidden' }}>
      <image href={scene} width="1672" height="941" style={{ imageRendering: 'pixelated' }} />
      <g shapeRendering="crispEdges">
        {Array.from({ length: 18 }, (_, i) => {
          const x = 340 + (i * 137) % 730;
          const y = 655 + (i * 37) % 140;
          return <rect key={i} data-pixel-ripple="true" x={x} y={y} width={12 + i % 5 * 7} height={2 + i % 2} fill={i % 3 ? '#b6f3ed' : '#fff1bf'} style={{ animationDelay: `${-i * .7}s`, animationDuration: `${3 + i % 4}s` }} />;
        })}
        {[0, 1, 2].map(i => (
          <g key={i} transform={`translate(${1280 + i * 65} ${80 + i * 38})`}>
            <path data-pixel-leaf="true" d="M0 0h8v4h4v8H4V8H0z" fill={i % 2 ? '#b2cf44' : '#69a438'} style={{ animationDelay: `${-i * 3.7}s`, animationDuration: `${14 + i * 2}s` }} />
          </g>
        ))}
      </g>
    </svg>
  );
}

export default React.memo(LivingPixelScene);
